module.exports = __webpack_public_path__ + "img/icon-sumar.b2845b3b.svg";